import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavBar from "../../Component/NavBar/Navbar";
import { fetchKeyTagData } from "../../API/api";
import SearchInput from "../../Component/SearchInput/searchInput";
import { DebounceInput } from "react-debounce-input";
import "./keyTagDataStyles.css";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import SkeletonLoader from "../../Component/SkeletonLoader/SkeletonLoader";
import InfiniteScroller from "../../Component/InfiniteScroll/InfiniteScroll";
import QuestionBox from "../../Component/QuestionBox/NewQuestionBox";
import { replacepercentageSymbol } from "../../utils";
import MiniDrawer from "../../Component/newNavBar/newNavBar";
import { Home_PAGE_URL } from "../../Router/routerUrl";

export default function KeyTagData() {
  const dispatch = useDispatch();
  const {
    getKeyTagsData,
    KeyTagsDataIsLoading,
    KeyTagsDataSearchQuery,
    isBackClickedOnRecommend,
    KeyTagsDataPageNoUpdate,
    KeyTagsDataSourceUpdate,
  } = bindActionCreators(Actions, dispatch);
  const navigate = useNavigate();
  const recommendState = useSelector((state) => state.recommend.isBack);
  let tagState = useSelector((state) => state.keyTag);
  const {
    tagSelectedPayload,
    pageNo,
    totalCount,
    data,
    isLoading,
    searchQuery,
  } = tagState;
  const [queryType, setQueryType] = useState(null);
  const [tabsearchQuery, setTabsearchQuery] = useState(searchQuery);
  const [isToggle, setIsToggle] = useState(queryType === "viz" ? true : false);
  const searchBar = () => {
    return (
      <div className="trendingsearchbar">
        <SearchInput />
      </div>
    );
  };

  const filterTab = () => {
    const onResetTabSearch = () => {
      setTabsearchQuery("");
      KeyTagsDataSearchQuery("");
    };
    const onChangeTabSearch = (e) => {
      setTabsearchQuery(e.target.value);
      KeyTagsDataSearchQuery(e.target.value);
    };

    const toggleQueryType = (bool) => {
      setTabsearchQuery("");
      setIsToggle(bool);
      setQueryType(bool ? "viz" : "expert");
      KeyTagsDataSourceUpdate(bool ? "viz" : "expert");
    };
    const goBack = () => {
      isBackClickedOnRecommend(true);
      setTimeout(() => {
        isBackClickedOnRecommend(false);
      }, 1000);
      navigate(-1);
    };
    return (
      <div className="trendingfilterbar">
        <div
          className="fiterbarInlineDisplaytrending"
          style={{ width: "100%" }}
        >
          <div style={{display:'flex',alignItems:'center'}}>
            <i
              className="fa fa-arrow-left trendingfiltertabtitle"
              style={{ cursor: "pointer",marginRight:'5px' }}
              onClick={() => goBack()}
            ></i>
            
            <span className="trendingfiltertabtitle" style={{marginRight:'5px'}}>
            {tagSelectedPayload && tagSelectedPayload.term}
            </span>
            {!isLoading && (
              <span className="datacount px-2 py-1">
                {data.length}/{totalCount === null ? 0 : totalCount}{" "}
                {queryType === "expert" ? "Expert Responses" : "user Queries"}
              </span>
              
            )}
          </div>
          <div style={{ marginTop: "11px", display: "flex" }}>
            {tagSelectedPayload &&
              tagSelectedPayload.vizCount !== 0 &&
              tagSelectedPayload.expertCount !== 0 && (
                <div style={{ marginTop: "-5.5px" }}>
                  <span
                    style={{
                      color: "grey",
                      fontSize: "14px",
                      fontWeight: "200",
                    }}
                  >
                    Expert Responses{" "}
                  </span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      disabled={isLoading}
                      onChange={(e) => toggleQueryType(e.target.checked)}
                      checked={isToggle}
                    />
                    <span className="slider2 round"></span>
                  </label>
                  <span
                    style={{
                      color: "grey",
                      fontSize: "14px",
                      fontWeight: "200",
                    }}
                  >
                    {" "}
                    User Queries
                  </span>
                </div>
              )}
            &nbsp;&nbsp;
            <div
              style={{
                color: "grey",
                border: "1px solid lightgrey",
                marginBottom: "5px",
                marginTop: "-8px",
                backgroundColor: "#fff",
                borderRadius: "4px",
                height: "fit-content",
              }}
            >
              <div style={{ display: "flex" }}>
                &nbsp;
                <i className="fa fa-search" style={{ marginTop: "5px" }}></i>
                <DebounceInput
                  minLength={0}
                  debounceTimeout={1000}
                  value={tabsearchQuery}
                  placeholder="Search..."
                  onChange={(e) => onChangeTabSearch(e)}
                  style={{
                    height: "27px",
                    border: "none",
                    fontSize: "12px",
                    color: "grey",
                    width: "78%",
                  }}
                />
                {tabsearchQuery.length > 0 && (
                  <i
                    className="fa fa-times"
                    style={{ marginTop: "5px", cursor: "pointer" }}
                    onClick={() => onResetTabSearch()}
                  ></i>
                )}
              </div>
            </div>
          </div>
        </div>
        <hr className="trendingtabpartition" />
      </div>
    );
  };

  const Loader = () => {
    return (
      <div className="trendingfilterbar">
        <SkeletonLoader />
      </div>
    );
  };

  const noDataAvailable = () => {
    return (
      <div className="trendingfilterbar" style={{ textAlign: "center" }}>
        <img
          src={require("../../Images/nothing_found.png")}
          style={{ opacity: ".4" }}
        />
        <p style={{ fontSize: "24px", fontWeight: "bold", opacity: ".7" }}>
          No QA Pair Available For Selected Term
        </p>
        <p style={{ fontSize: "20px", fontWeight: "bold", opacity: ".7" }}>
          You will receive the QA Pair shortly
        </p>
      </div>
    );
  };

  const renderQApair = (qapair) => {
    const sendToSearchPage = (query) => {
      navigate(
        `${Home_PAGE_URL}search/${encodeURIComponent(
          replacepercentageSymbol(query)
        )}/false`
      );
    };
    return (
      <InfiniteScroller
        isLoading={isLoading}
        dataLength={data.length}
        nextFunc={() => fetchMore()}
        cssClassName={"keyTagsUserQuery"}
        hasMore={true}
      >
        {qapair.map((qa) => {
          return (
            <div className="ktuserquery2">
              <div
                className="ktuserquery"
                onClick={() => sendToSearchPage(qa.text)}
              >
                {qa.text}
              </div>
            </div>
          );
        })}
      </InfiniteScroller>
    );
  };
  const renderQApairExpertResponse = (data) => {
    return (
      <InfiniteScroller
        isLoading={isLoading}
        dataLength={data.length}
        nextFunc={() => fetchMore()}
        cssClassName={"trendingQA"}
        hasMore={true}
      >
        {data.map((qa, index) => {
          return <QuestionBox key={index} data={qa} />;
        })}
      </InfiniteScroller>
    );
  };
  const getKeyTagsQuery = () => {
    setQueryType(tagState.tagSelectedPayload.source);
    if (!recommendState) {
      if (pageNo === 0) {
        KeyTagsDataIsLoading(true);
      }
      let isaqw = queryType == null ? tagSelectedPayload.source : queryType;
      fetchKeyTagData(
        pageNo,
        tagSelectedPayload.term,
        tagState.tagSelectedPayload.source,
        tabsearchQuery
      ).then((res) => {
        if (res===undefined) return;
        if (res.data.success) {
          if (res.data.data === undefined) {
            getKeyTagsData({ data: [], count: 0 });
            return;
          } else {
            getKeyTagsData({
              data: res.data.data.tagsQaData,
              count: res.data.data.totalCount,
            });
          }
        }
      });
    }
  };

  const fetchMore = () => {
    let totalCount = tagState.totalCount;
    let currentDataCount = tagState.data.length;
    let upcomingPage = tagState.pageNo + 1;
    if (currentDataCount < totalCount) {
      setTimeout(() => {
        KeyTagsDataPageNoUpdate(upcomingPage);
      }, 500);
    }
  };
  useEffect(() => {
    if (tagState.tagSelectedPayload === null) {
      navigate("/seekerHome/");
      return;
    }
    getKeyTagsQuery();
  }, [
    tagSelectedPayload,
    tagSelectedPayload && tagSelectedPayload.source,
    tabsearchQuery,
    tagState.pageNo,
  ]);

  return (
    <>
      <div>
        <MiniDrawer>
          {searchBar()}
          {filterTab()}
          {!isLoading && data.length === 0 && noDataAvailable()}
          {!isLoading &&
            data.length > 0 &&
            queryType === "viz" &&
            renderQApair(data)}
          {!isLoading &&
            data.length > 0 &&
            queryType === "expert" &&
            renderQApairExpertResponse(data)}
          {isLoading && tagState.pageNo === 0 && Loader()}
        </MiniDrawer>
      </div>
    </>
  );
}
